<template>
  <div class="miya-proxy-data">
    <div class="dataList">
      <div class="item" v-for="(item, idx) in dataList" :key="'data'+idx">
        <p class="name">{{item.name}}<i class="icon-line" v-if="idx===0"></i></p>
        <p class="data"><miya-number :dataValue="item.value"></miya-number><span v-if="idx===2" class="percent">{{dataPercent}}</span></p>
      </div>
      <miya-btn class="buyBtn" ref="buyBtn" :title="$t('menu.m2_3')" @click="clickBtn">
        <template slot="icon">
          <i class="el-icon-arrow-right"></i>
        </template>
      </miya-btn>
    </div>
  </div>
</template>
<script>
import miyaNumber from '@components/miyaNumber.vue'
import miyaBtn from '@components/miyaBtn.vue'
export default {
  data () {
    return {}
  },
  props: {
    dataList: {
      type: Array,
      default: () => {return []}
    },
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataPercent () {
      let num = this.dataList[0].value == 0 ? 0 : this.dataList[2].value / this.dataList[0].value
      return `[${(num*100).toFixed(2)}%]`
    }
  },
  methods: {
    clickBtn () {
      this.$emit('click')
    }
  },
  components: {miyaNumber, miyaBtn}
}
</script>
<style scoped lang="stylus">
.miya-proxy-data
  margin-bottom 42px
  .dataList
    display flex
    padding-bottom 20px
    border-bottom 1px solid rgba(40,30,20,0.2)
    .item
      flex 1
      color $c1
      position relative
      .name
        font-size $f14 
        margin-bottom 16px   
        display flex
        .icon-line
          width 26px
          height 14px
          margin-left 8px
          background url('../assets/images/dynamic/icon-line.svg')
          animation lineMove 1.5s ease-in infinite
      .data
        font-size 28 px
        .percent
          font-size $f16
          color $c8
          margin-left 8px
      &:after
        content ''
        display block
        position absolute
        width 1px
        height 40px
        top 50%
        right 40%
        background-color $c5
        transform translate3d(0,-50%,0)
      &:nth-of-type(3)
        &:after
          width 0
    .buyBtn
      height 36px
      background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
      color $c7
      fontWeight()
      line-height 36px
      font-size $f14
      border-radius 2px
      cursor pointer
      position relative
      margin-top 12px
      padding 0 40px 0 20px
      .el-icon-arrow-right
        position absolute
        top 12px
        fontWeight()
        right 20px
@media screen and (max-width: 800px)
  .miya-proxy-data
    margin-bottom 1.5rem
    .dataList
      flex-wrap wrap
      .item
        flex auto
        width 42%
        margin-right 1rem
        margin-bottom 1.5rem
        .name
          font-size 0.8rem
        .data
          font-size 1.2rem
        &:after
          right 0
        &:nth-of-type(2)
          margin-right 0
          &:after
            width 0
      .buyBtn
        font-size 0.7rem
        padding 0 1.5rem 0 1rem
        .el-icon-arrow-right
          right 0.5rem
@keyframes lineMove
  0%
    width 0
  100%
    width 26px
</style>